// Copyright © 2022 Vewd Software AS.
//
// This file is part of Vewd Cloud,
// and includes Vewd Confidential Information.
// Distribution is strictly prohibited without Vewd's written consent.
import { useMemo } from "react";

import { useField } from "formik";
import PropTypes from "prop-types";

import { getFieldTestId } from "utils/formik";

import { createMixedValidator } from ".";
import { Input } from "../elements";
import { FieldProps } from "./propTypes";

export const NumberField = (props) => {
  const {
    name,
    max,
    min,
    required = true,
    step,
    dataTestId,
    validate: validateFn,
  } = props;

  const validate = useMemo(
    () => createMixedValidator(name, required, validateFn),
    [name, required, validateFn]
  );

  const [field, meta] = useField({
    ...props,
    required,
    type: "number",
    validate,
  });

  return (
    <Input
      {...meta}
      {...props}
      props={{
        ...field,
        min,
        max,
        step,
      }}
      required={required}
      type="number"
      dataTestId={dataTestId || getFieldTestId(name)}
    />
  );
};

NumberField.propTypes = {
  ...FieldProps,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
};
